import { Box, Paper, Typography, useTheme } from '@mui/material';
import React, { FC, useEffect, useMemo } from 'react';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { GoPlus } from "react-icons/go";
import { Table } from '../../../Components/Table/table.component';
import { useNavigate } from 'react-router-dom';
import { ListProductUseCase } from '../../../Usecase/Products/list-product-usecase';
import { useListCollaborators } from './collaborators-list.hook';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Loader } from '../../../Components/Loader';
import { ListCollaboratorsUseCase } from '../../../Usecase/Collaborators/list-collaborators-usecase';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { ConfirmDialog } from '../../../Components/Dialog/variants/dialog-confirmation/dialog-confirmation.component';
import { DestroyCollaboratorsUseCase } from '../../../Usecase/Collaborators/destroy-collaborators-usecase';
import { Can } from '../../../Components/Can';

interface ICollaboratorsList {
  listCollaboratorsUseCase: ListCollaboratorsUseCase
  destroyCollaboratorsUseCase: DestroyCollaboratorsUseCase
}
const CollaboratorsList : FC<ICollaboratorsList> = ({ listCollaboratorsUseCase, destroyCollaboratorsUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { listCollaborators, list, data, loading, setCollaboratorToDestroy, collaboratorToDestroy, handleDestroyCollaborator, totalRegisters } = useListCollaborators({
      listCollaboratorsUseCase,
      destroyCollaboratorsUseCase
    })

    useEffect(() => {
      listCollaborators({ page: 1, search: '' })
    }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
       
          
          {
            field: 'name',
            headerName: 'Colaborador',
            flex: 1
          },
          {
            field: 'username',
            headerName: 'E-mail',
            flex: 1
          },
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "center",
            align: "center",
            width: 100,
            renderCell: (params: any) => <ActionButtons params={params ?? {}} setItemToDestroy={() => setCollaboratorToDestroy(params?.row?.id)} editFunction={() => navigate(`/collaborators-form/${params?.row?.id}`)} />
            }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:collaborators:manage']}>
        <BaseScreen>
        <ConfirmDialog title='Remover Colaborador' onCancel={() => setCollaboratorToDestroy('')} description='Você tem certeza?' open={!!collaboratorToDestroy} onConfirm={handleDestroyCollaborator}  /> 
            <Paper >
              {loading && <Loader />}
                <BaseContentPage 
                    title='Colaboradores'
                    breadcrumb={[{ title: 'Colaboradores', link: "/collaborators-list"}, { title: 'Listagem'}]}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/collaborators-form')}>Adicionar</Button>}
                >
                  {!!list?.length ? <Table data={list} columns={columns} totalCount={totalRegisters} /> : <Placeholder description='Nenhum dado encontrado.' /> }
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
      </Can>
    )
}

export { CollaboratorsList }